import React, { PureComponent } from 'react';
import { SofaPanel } from '@sofology/sofologycomponents';

import './PaymentLoader.scss';

import { Loader } from 'components';

interface OwnProps {
    message: string;
}

export default class PaymentLoader extends PureComponent<OwnProps> {
    render(): JSX.Element {
        return (
            <SofaPanel>
                <div className='payment-loader'>
                    <div className='payment-loader__wrapper'>
                        <Loader show={true} />
                    </div>
                    <div className='payment-loader__message'>{this.props.message}</div>
                </div>
            </SofaPanel>
        );
    }
}